const API = 'API'

const appTypes = {
  backToState: 'BACK_TO_STATE',
  setDS: 'SET_DATA_STRACTURE',
  setAction: 'SET_ACTION',
  setAlgorithm: 'SET_ALGORITHM',
  set: 'SET',
}

const matrixTypes = {
  setSquare: 'SET_SQUARE',
  resetMatrix: 'RESET_MATRIX',
  clearVisited: 'CLEAR_VISITED',
}

export {
  appTypes,
  API,
  matrixTypes,
}
